<template>
    <div>
        <div class="card">
            <div class="card-header main-card">
                Administración de subzonas de recogida
            </div>
            <div class="card-body">
                <b-container>
                    <div class="mb-4">
                        <span class="mr-4">
                            Selecciona la zona
                        </span>
                        <b-form-select @change="getData" v-model="suprazone_id" class="">
                            <option value="0">Seleccione zona...</option>
                            <option v-for="suprazone in suprazones" :key="suprazone.id" :value="suprazone.id">{{suprazone.name}}</option>
                        </b-form-select>
                        <b-dropdown
                            v-if="suprazone_id > 0"
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addPickupzone'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nueva
                                </div>
                                <admin-add-pickupzone-modal :suprazone="suprazone" />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                   
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <admin-pickupzones-table-row 
                                :item="pickupzone" v-for="pickupzone in pickupzonesListAdmin" :key="pickupzone.id"
                                :suprazone="suprazone" />
                        </tbody>
                    </table>
                </b-container>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import AdminPickupzonesTableRow from './AdminPickupzonesTableRow'
import AdminAddPickupzoneModal from './AdminAddPickupzoneModal'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminPickupzonesTableRow,
        AdminAddPickupzoneModal,
    },
    data() {
        return {
            suprazone: {},
            suprazone_id: 0,
        }
    },
    beforeDestroy() {
        // clean list
        this.$store.commit('pickupzones/RESET_PICKUPPOINTS_LIST_ADMIN')
    },
    async mounted() {
        await this.$store.dispatch("suprazones/loadSuprazones")
    },
    computed: {
        ...mapGetters(['suprazones', 'suprazoneAdminCurrent', 'pickupzonesListAdmin'])
    },
    methods: {
        async getData() {
            if ( this.suprazone_id > 0) {
                this.$store.dispatch('pickupzones/loadPickupzonesBySuprazone', this.suprazone_id)
                this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)
            }
            

        }
    }
}
</script>
